// TextInputBadge — маленький «T» badge для pure text-моделей в widget'е
// (когда никакой upload не нужен, но юзеру визуально понятно «это text2text»).
//
// Извлечён из GenerateInputBar.tsx — нужен в UploadsRow.tsx.

export interface TextInputBadgeProps {
	taskType: string
}

export default function TextInputBadge(_: TextInputBadgeProps) {
	return (
		<div className="gm-text-badge">
			<span className="gm-text-badge__letter">T</span>
		</div>
	)
}
